exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input[data-v-db28450c]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.input__header[data-v-db28450c]{margin-bottom:12px;font-family:Open Sans,sans-serif;font-size:13px;font-weight:400;line-height:1.35;color:#1a1a1a}@media only screen and (min-width:40.063em){.input__header[data-v-db28450c]{margin-bottom:19px;font-size:14px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-db28450c","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/form/formrange/FormRange.vue
// module id = 19565499c0e8167afb13
// module chunks = 5